import * as React from 'react';

export interface DropdownElement {
	id: number;
	text: string;
	isActive: boolean;
}

export interface Props {
	elements: DropdownElement[];
	onClick: (id: number) => void;
	className: string;
	value: number;
	asPlainText?: boolean;
}

export const Dropdown: React.FunctionComponent<Props> = props => {
	const handleChange = (event: any) => {
		props.onClick(event.target.value);
	};

	return (
		<div className={props.className}>
			{!props.asPlainText ? (
				<select onChange={handleChange} value={props.value}>
					{props.elements.map((element, index) => (
						<option value={element.id} disabled={!element.isActive} key={index}>
							{element.text}
						</option>
					))}
				</select>
			) : props.children ? (
				props.children
			) : (
				''
			)}
		</div>
	);
};
